<div class="main-container">
  <!-- TO DO: - use bp-select which when ng-select is added -->
  <!-- Primary dropdown - Monthly, Weekly, Daily -->
  <div class="dropdown-container">
    <ng-select
      class="default-fs-theme"
      [items]="frequencyDropdownModel.primaryDropdownList"
      [(ngModel)]="frequencyDropdownModel.primarySelection"
      [searchable]="false"
      [clearable]="false"
      (change)="changedValue($event)">
      <ng-template ng-option-tmp ng-label-tmp let-item="item">
        <div class="card">
          <div class="card-body">
            <span class="card-title font-size-15">
              <span class="card-title__item card-title__item__name">
                <span>{{ item.name }}</span>
              </span>
            </span>
          </div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <div class="dropdown-container">
    @if (!isPrimarySelectionEmpty()) {
      <span class="bpi__icon-calendar dropdown-icon"></span>
    }
    <!-- Secondary dropdown - Monday, Thursday, Friday / 1st, 2nd, 3rd, 25th -->
    @if (!isPrimarySelectionEmpty()) {
      <div class="joined-container">
        <ng-select
          class="default-fs-theme"
          [items]="frequencyDropdownModel.primarySelection?.range"
          [(ngModel)]="frequencyDropdownModel.secondarySelection"
          [searchable]="false"
          [clearable]="false"
          (change)="changedValue()">
          <ng-template ng-option-tmp ng-label-tmp let-item="item">
            <div class="card">
              <div class="card-body">
                <span class="card-title font-size-15">
                  <span class="card-title__item card-title__item__name">
                    <span>{{ item.name }}</span>
                  </span>
                </span>
              </div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    }
    <span class="bpi__icon-time dropdown-icon"></span>
    <!-- Time dropdown - 12:30, 13:00, 13:30 -->
    <div class="joined-container">
      <ng-select
        class="default-fs-theme"
        [items]="frequencyDropdownModel.tertiaryDropdownList"
        [(ngModel)]="frequencyDropdownModel.tertiarySelection"
        [searchable]="false"
        [clearable]="false"
        (change)="changedValue()"
        [virtualScroll]="true">
        <ng-template ng-option-tmp ng-label-tmp let-item="item">
          <div class="card">
            <div class="card-body">
              <span class="card-title font-size-15">
                <span class="card-title__item card-title__item__name">
                  <span>{{ item }}</span>
                </span>
              </span>
            </div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>
</div>
